import { permanentMethods } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function PermanentEntry() {
  return (
    <section id="permanent" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <SectionHeading
          eyebrow="永久入口 · 防走失"
          title="收藏这几种方式，再也不怕找不到"
          desc="域名会变，但获取最新地址的方法可以一直有效。把下面几种方式组合使用，即使某天所有旧地址都失效，你也能第一时间找回入口。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="h-64 w-full md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20glowing%20golden%20doorway%20with%20film%20strip%20ribbon%20curving%20through%20it%20on%20cream%20background%2C%20warm%20amber%20tones%2C%20minimal%20elegant%20concept%20art%2C%20soft%20shadows&width=800&height=800&seq=cinema-entry-04&orientation=squarish"
                  alt="象征永久入口的发光门与胶片丝带插画"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  最省心的一条建议
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  把本页加入浏览器书签，并同时绑定邮箱。这样即使官方更换主域名，你也能通过本页或邮件通知，
                  一步找到最新可用的星辰影院入口。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {permanentMethods.map((item) => (
                <article
                  key={item.id}
                  className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}